<ng-container *ngIf="showInvoiceDtls==false">
    <div class="invoice_page">
        <div class="search">
            <input type="text" class="search__input" placeholder="Search Invoice Name/Invoice Number/ Client Name" [(ngModel)]="searchKeyword" (input)="onSearch()" >
            <button class="search__button">
                <svg class="search__icon">
                    <use xlink:href="./assets/img/sprite.svg#icon-search"></use>
                </svg>
            </button>
        </div>
    
        <div class="invoice__container" (scroll)="onScroll($event)">
            <a *ngIf="this.currentMenuDtls.roleacc_is_edit" pTooltip="Click to add new invoice" tooltipPosition="top" class="invoice__item invoice__item__new" (click)="addInvoice()">
                <svg class="search__icon">
                    <use xlink:href="./assets/img/sprite.svg#icon-plus"></use>
                </svg>
            </a>
            <ng-container *ngFor="let item of invoice_current_datasource">
                <a class="invoice__item" >
                    <img *ngIf="item.clnt_company_logo=='https://www.chemrobotics.com/agropat/images/innovators_logo/'" src="../../../assets/img/invoicethumb.png" alt="">
                    <img *ngIf="item.clnt_company_logo!='https://www.chemrobotics.com/agropat/images/innovators_logo/'"
                        [attr.src]="item.clnt_company_logo"
                        [alt]="item.clnt_company_name"
                    />
                    <span>{{item.invoice_name}}</span>

                    <div class="invoice__item__action">
                        <button pTooltip="Edit" tooltipPosition="bottom" *ngIf="this.currentMenuDtls.roleacc_is_edit" (click)="actionInvoice(item,'edit')"
                            class="btn btn--green btn--round"
                            type="button" 
                        >
                            <svg class="btn__icon">
                                <use xlink:href="./assets/img/sprite.svg#icon-edit-3"></use>
                            </svg>
                        </button>
                        <button pTooltip="Download" tooltipPosition="bottom" *ngIf="this.currentMenuDtls.roleacc_is_view || this.currentMenuDtls.roleacc_is_edit" (click)="actionInvoice(item,'download')"
                            class="btn btn--green btn--round"
                            type="button" 
                        >
                            <svg class="btn__icon">
                                <use xlink:href="./assets/img/sprite.svg#icon-download"></use>
                            </svg>
                        </button>
                        <button pTooltip="View" tooltipPosition="bottom" *ngIf="this.currentMenuDtls.roleacc_is_delete==false" (click)="actionInvoice(item,'preview')"
                            class="btn btn--green btn--round"
                            type="button" 
                        >
                            <svg class="btn__icon">
                                <use xlink:href="./assets/img/sprite.svg#icon-eye"></use>
                            </svg>
                        </button>
                        <button pTooltip="Delete" tooltipPosition="bottom" *ngIf="this.currentMenuDtls.roleacc_is_delete" (click)="actionInvoice(item,'delete')"
                            class="btn btn--green btn--round"
                            type="button" 
                        >
                            <svg class="btn__icon">
                                <use xlink:href="./assets/img/sprite.svg#icon-trash"></use>
                            </svg>
                        </button>
                    </div>
                </a>
            </ng-container>            
           
        </div>
    
    </div>
</ng-container>



<!-- Invoice Template Detail Page -->
<ng-container *ngIf="showInvoiceDtls==true">
    <div class="invoice">
        <!-- Invoice Form -->
        <div class="invoice__form">
            <!-- Main Detail Form -->
            <form [formGroup]="invoiceForm" (ngSubmit)="saveInvoiceForm()">
                <div class="invoice__form__action">
                    <h2 class="master__form__subheading">
                        <svg class="btn__icon" >
                        <use xlink:href="./assets/img/sprite.svg#icon-file-text"></use>
                    </svg>&nbsp;Invoice Details
                    </h2>

                    <div class="invoice__form__action__buttons">
                        <button 
                        class="btn btn--green u-margin-right-vsmall"
                        [disabled]="invoiceForm.invalid" 
                        type="submit" 
                        >
                            <svg class="btn__icon">
                                <use xlink:href="./assets/img/sprite.svg#icon-check-square"></use>
                            </svg>
                        &nbsp;Save
                        </button>
                        <button 
                        class="btn btn--white" 
                        type="button"
                        (click)="showInvoiceDtls=false" 
                        >
                            <svg class="btn__icon">
                                <use xlink:href="./assets/img/sprite.svg#icon-x"></use>
                            </svg>
                        &nbsp;Cancel
                        </button>
                    </div>
                
                </div>
                <!-- Invoice Name -->
                <div class="form__group">
                    <label for="invoice name" class="form__label form__label--master">
                        Invoice name
                        <span  class="form__group__mandatory">&lowast;</span></label>
                    <input
                    type="text"
                    class="form__input--master"
                    [ngClass]="{
                        'form__input--master--invalid':
                        (invoiceForm.controls['invoice_name'].invalid &&
                            (invoiceForm.controls['invoice_name'].dirty ||
                            invoiceForm.controls['invoice_name'].touched)) === true
                    }"
                    autocomplete="off"
                    placeholder="Enter invoice name"
                    formControlName="invoice_name"
                    id="invoice_name"
                    />
                    <div
                        *ngIf="
                        invoiceForm.controls['invoice_name'].invalid &&
                        (invoiceForm.controls['invoice_name'].dirty ||
                            invoiceForm.controls['invoice_name'].touched)
                        "
                        class="alert alert-danger"
                    >
                        <div *ngIf="invoiceForm.controls['invoice_name'].errors.required">
                        Invoice Name is required.
                        </div>
                    </div>  
                </div>
                
                <!-- Invoice Client -->
                <div class="form__group">
                    <label for="invoice name" class="form__label form__label--master">
                        Client name
                        <span  class="form__group__mandatory">&lowast;</span></label>
                        <p-autoComplete 
                            inputStyleClass="form__input--master"
                            placeholder="Search and select client"
                            formControlName="invoice_client_id"
                            field="clnt_company_name"
                            [suggestions]="clientAutocompleteDtls" 
                            (completeMethod)="searchClient($event)"> 
                            <ng-template let-client pTemplate="item">
                                <div class="invoice__autocompleteitem">
                                    <div>{{client.clnt_company_name}}</div>
                                    <img *ngIf="client.clnt_company_logo!=''" [attr.src]="'https://www.chemrobotics.com/agropat/images/innovators_logo/'+client.clnt_company_logo" />
                                </div>
                            </ng-template>   
                        </p-autoComplete>
                    <!-- <input
                    type="text"
                    class="form__input--master"
                    [ngClass]="{
                        'form__input--master--invalid':
                        (invoiceForm.controls['invoice_client_id'].invalid &&
                            (invoiceForm.controls['invoice_client_id'].dirty ||
                            invoiceForm.controls['invoice_client_id'].touched)) === true
                    }"
                    autocomplete="off"
                    placeholder="Enter client name"
                    formControlName="invoice_client_id"
                    id="invoice_client_id"
                    /> -->
                    <div
                        *ngIf="
                        invoiceForm.controls['invoice_client_id'].invalid &&
                        (invoiceForm.controls['invoice_client_id'].dirty ||
                            invoiceForm.controls['invoice_client_id'].touched)
                        "
                        class="alert alert-danger"
                    >
                        <div *ngIf="invoiceForm.controls['invoice_client_id'].errors.required">
                        Client name is required.
                        </div>
                    </div>  
                </div>
                <!-- Invoice Number -->
                <div class="form__group">
                    <label for="invoice number" class="form__label form__label--master">
                        Invoice Number
                        <span  class="form__group__mandatory">&lowast;</span></label>
                    <input
                    type="text"
                    class="form__input--master"
                    [ngClass]="{
                        'form__input--master--invalid':
                        (invoiceForm.controls['invoice_number'].invalid &&
                            (invoiceForm.controls['invoice_number'].dirty ||
                            invoiceForm.controls['invoice_number'].touched)) === true
                    }"
                    autocomplete="off"
                    placeholder="Enter client name"
                    formControlName="invoice_number"
                    id="invoice_number"
                    /> 
                    <div
                        *ngIf="
                        invoiceForm.controls['invoice_number'].invalid &&
                        (invoiceForm.controls['invoice_number'].dirty ||
                            invoiceForm.controls['invoice_number'].touched)
                        "
                        class="alert alert-danger"
                    >
                        <div *ngIf="invoiceForm.controls['invoice_number'].errors.required">
                        Invoice Number is required.
                        </div>
                    </div>  
                </div>
                <!-- Invoice date -->
                <div class="form__group">
                    <label for="invoice name" class="form__label form__label--master">
                        Invoice date
                        <span  class="form__group__mandatory">&lowast;</span></label>
                    <div class="form__date__group">
                        <input 
                        class="form__date__field" 
                        autocomplete="off" 
                        placeholder="Click to select a invoice date"
                        angular-mydatepicker name="mydate" (click)="dp.toggleCalendar()" [options]="myDpOptions" 
                        formControlName="invoice_date"
                        #dp="angular-mydatepicker"/>
                        <svg class="form__date__icon">
                        <use xlink:href="./assets/img/sprite.svg#icon-calendar"></use>
                        </svg>
                    </div>
                    <div
                        *ngIf="
                        invoiceForm.controls['invoice_date'].invalid &&
                        (invoiceForm.controls['invoice_date'].dirty ||
                            invoiceForm.controls['invoice_date'].touched)
                        "
                        class="alert alert-danger"
                    >
                        <div *ngIf="invoiceForm.controls['invoice_date'].errors.required">
                        Invoice date is required.
                        </div>
                    </div>  
                </div>
            </form>

            <!-- Case Detail Form -->
            <form class="invoice__form__cases">
                <div class="invoice__form__cases__item  invoice__form__cases__item__header">
                    <div>
                        Cases / Description
                    </div>
                    <div>
                        Database Access
                    </div>
                    <div>
                        Users
                    </div>
                    <div>
                        Term
                    </div>
                    <div>
                        Offered price
                    </div>
                    <div>
                        Amount
                    </div>
                </div>

                <div class="invoice__form__cases__item" [formGroup]="invoiceCaseForm">
                    <div>
                        <textarea
                        type="text"
                        class="form__input--master"
                        autocomplete="off"
                        placeholder="Enter Cases / Description"
                        id="invoice_case_desc"
                        formControlName="case_desc"
                        ></textarea>
                        <div
                        *ngIf="
                        invoiceCaseForm.controls['case_desc'].invalid &&
                        (invoiceCaseForm.controls['case_desc'].dirty ||
                            invoiceCaseForm.controls['case_desc'].touched)
                        "
                        class="alert alert-danger"
                        >
                            <div *ngIf="invoiceCaseForm.controls['case_desc'].errors.required">
                            required.
                            </div>
                        </div>  
                    </div>
                    <div>
                        <textarea
                        type="text"
                        class="form__input--master"
                        autocomplete="off"
                        placeholder="Enter Database Access"
                        id="invoice_case_dbaccess"
                        formControlName="databse_access"
                        ></textarea>
                        <div
                        *ngIf="
                        invoiceCaseForm.controls['databse_access'].invalid &&
                        (invoiceCaseForm.controls['databse_access'].dirty ||
                            invoiceCaseForm.controls['databse_access'].touched)
                        "
                        class="alert alert-danger"
                        >
                            <div *ngIf="invoiceCaseForm.controls['databse_access'].errors.required">
                            required.
                            </div>
                        </div>
                    </div>
                    <div>
                        <textarea
                        type="text"
                        class="form__input--master"
                        autocomplete="off"
                        placeholder="Enter Users"
                        id="invoice_case_users"
                        formControlName="users"
                        ></textarea>
                        <div
                        *ngIf="
                        invoiceCaseForm.controls['users'].invalid &&
                        (invoiceCaseForm.controls['users'].dirty ||
                            invoiceCaseForm.controls['users'].touched)
                        "
                        class="alert alert-danger"
                        >
                            <div *ngIf="invoiceCaseForm.controls['users'].errors.required">
                            required.
                            </div>
                        </div>
                    </div>
                    <div>
                        <textarea
                        type="text"
                        class="form__input--master"
                        autocomplete="off"
                        placeholder="Enter Term"
                        id="invoice_case_term"
                        formControlName="term"
                        ></textarea>
                        <div
                        *ngIf="
                        invoiceCaseForm.controls['term'].invalid &&
                        (invoiceCaseForm.controls['term'].dirty ||
                            invoiceCaseForm.controls['term'].touched)
                        "
                        class="alert alert-danger"
                        >
                            <div *ngIf="invoiceCaseForm.controls['term'].errors.required">
                            required.
                            </div>
                        </div>
                    </div>
                    <div>
                        <textarea
                        type="text"
                        class="form__input--master"
                        autocomplete="off"
                        placeholder="Enter Offered price"
                        id="invoice_case_offprice"
                        formControlName="offered_price"
                        ></textarea>
                        <div
                        *ngIf="
                        invoiceCaseForm.controls['offered_price'].invalid &&
                        (invoiceCaseForm.controls['offered_price'].dirty ||
                            invoiceCaseForm.controls['offered_price'].touched)
                        "
                        class="alert alert-danger"
                        >
                            <div *ngIf="invoiceCaseForm.controls['offered_price'].errors.required">
                            required.
                            </div>
                            <div *ngIf="invoiceCaseForm.controls['offered_price'].errors.pattern">
                                Only number
                            </div>
                            <div *ngIf="invoiceCaseForm.controls['offered_price'].errors.maxlength">
                                10 digit only
                            </div>
                        </div>
                    </div>
                    <div>
                        <textarea
                        type="text"
                        class="form__input--master"
                        autocomplete="off"
                        placeholder="Enter Amount"
                        id="invoice_case_amount"
                        formControlName="amount"
                        ></textarea>
                        <div
                        *ngIf="
                        invoiceCaseForm.controls['amount'].invalid &&
                        (invoiceCaseForm.controls['amount'].dirty ||
                            invoiceCaseForm.controls['amount'].touched)
                        "
                        class="alert alert-danger"
                        >
                            <div *ngIf="invoiceCaseForm.controls['amount'].errors.required">
                                required.
                            </div>
                            <div *ngIf="invoiceCaseForm.controls['amount'].errors.pattern">
                                Only number
                            </div>
                            <div *ngIf="invoiceCaseForm.controls['amount'].errors.maxlength">
                                10 digit only
                            </div>
                        </div>
                    </div>
                </div>
                
                <a
                      class="btn--link invoice__btn__add"
                      title="Add New Column"
                      [class.disabled]="invoiceCaseForm.invalid"
                      (click)="addCaseData()"
                    >
                      <svg>
                        <use
                          xlink:href="./assets/img/sprite.svg#icon-plus-circle"
                        ></use>
                      </svg>
                </a>
                <div class="invoice__form__cases__dtls">
                    <ng-container *ngFor="let item of invoiceCaseData">
                        <div class="invoice__form__cases__dtls__item">
                            <div>
                                <span>{{item.case_desc}}</span>
                            </div>
                            <div>
                                <span>{{item.databse_access}}</span>
                            </div>
                            <div>
                                <span>{{item.users}}</span>
                            </div>
                            <div>
                                <span>{{item.term}}</span>
                            </div>
                            <div>
                                <span>{{item.offered_price}}</span>
                            </div>
                            <div>
                                <span>{{item.amount}}</span>
                            </div>
                            <div>
                                <a
                                class="btn--link"
                                title="Delete"
                                (click)="removeCaseData(item)"
                                >
                                <svg>
                                    <use xlink:href="./assets/img/sprite.svg#icon-trash-2"></use>
                                </svg>
                                </a>
                            </div>
                        </div>  
                    </ng-container>
                    <ng-container *ngIf="invoiceCaseData.length==0">
                        <span>No item added! Please fill above case detail form and click add button.</span>
                    </ng-container>
                </div>
                  
            </form>

        </div> 
        <!-- Invoice Page   -->
        <div class="invoice__page__preview">
            <div class="invoice__page__preview__heading">
                <h2  class="master__form__subheading">
                    <svg  class="btn__icon"><use 
                        xlink:href="./assets/img/sprite.svg#icon-eye"></use></svg>
                    &nbsp;Invoice Preview </h2>
                    <div class="invoice__page__preview__heading__action">
                        <button 
                        class="btn btn--green u-margin-right-vsmall" 
                        type="button" (click)="downloadAsPDF('download')"
                        >
                            <svg class="btn__icon">
                                <use xlink:href="./assets/img/sprite.svg#icon-download"></use>
                            </svg>
                        &nbsp;Download
                        </button>   
                        <button 
                        class="btn btn--white u-margin-right-vsmall" 
                        type="button" (click)="downloadAsPDF('preview')"
                        >
                            <svg class="btn__icon">
                                <use xlink:href="./assets/img/sprite.svg#icon-eye"></use>
                            </svg>
                        &nbsp;Preview
                        </button>
                    </div>
                
            </div>
            <div class="invoice__page" >
                <!-- header -->
                <div class="invoice__page__header">
                    <div class="invoice__page__header__compdtls" style="display: flex;flex-direction: column;">
                        <h1 style="color: #1769aa;font-size: 2.3rem;">ChemRobotics Private Limited</h1>
                        <h3 style="color: #1769aa;">CIN NO. U74999MP2018PTC046833</h3>
                        <h3 style="color: #1769aa;">GST REG NO. 23AAHCC8027F1ZW</h3>
                        <h3 style="color: #1769aa;">PAN NO. AAHCC8027F</h3>
                    </div>
                   <!-- <img src="../../../assets/img/logo.png" alt=""> -->
                   <img src="data:image/png;base64,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" alt="">
                </div>
                <hr class="invoice__hr" >
                <!-- invoice details -->
                <div class="invoice__page__dtls">
                    <span>Offer Pricing for {{this.invoiceForm.controls.invoice_client_id.value?.clnt_company_name}}.</span>
                    <div class="">
                        <div class="invoice__page__dtls__address">
                            <span>To,</span>
                            <span>M/s. {{this.invoiceForm.controls.invoice_client_id.value?.clnt_company_name}}.</span>
                        </div>
                        <div class="invoice__page__dtls__info">
                         <span>DATE : {{this.invoiceForm.controls.invoice_date.value?.singleDate.formatted}}</span>
                         <span>INVOICE NO. {{this.invoiceForm.controls.invoice_number.value}}</span>
                     </div>
                        
                    </div>
                    <div class="invoice__page__dtls__prodoffer">
                        <span>Product Offer Pricing: All Database Access Pack - Indian Platinum Pack (IPP)* </span>
                        <p>
                            * IPP is a special discounting pricing pack, applicable for Indian origin companies only, 
                            wherein user will be subscribing all ten ChemRobotics databases including AgroPat Lite, AgroPat Ultimate, IPD, Global MRL, 
                            Global Agro Product Directory, JARVIS AgroPat, Technical Routes, Technical Suppliers, AgroPharm XIM DB & PharmVetPat Ultimate  
                            <b>- Global companies, ChemRobotics has independent pricing model named as “Global Pricing Model” (GPM)</b> 
                        </p>
                    </div>
                </div>
                <!-- cases -->
                <div class="invoice__page__cases">
                    <span>All ChemRobotics Databases Access - Indian Platinum Pack (IPP)</span>
                    <div class="invoice__page__cases__table">
                        <div class="invoice__page__cases__table__item invoice__page__cases__table__item__heading">
                            <span>S.N</span>
                            <span>Cases / Description</span>
                            <span>Database Access</span>
                            <span>Users</span>
                            <span>Term</span>
                            <span>Offered price</span>
                            <span>Amount</span>
                        </div>
                        <ng-container *ngFor="let item of invoiceCaseData; let i=index">
                            <div class="invoice__page__cases__table__item">
                                <span>{{i+1}}</span>
                                <span>{{item.case_desc}}</span>
                                <span>{{item.databse_access}}</span>
                                <span>{{item.users}}</span>
                                <span>{{item.term}}</span>
                                <span>{{item.offered_price}}</span>
                                <span>{{item.amount}}</span>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <!-- terms and conditions -->
                <div class="invoice__page__terms">
                    <span>Terms and Condition: -</span>
                    <ul>
                        <li>
                            <div class="invoice__page__terms__item">
                                <span>1.Tax</span>
                                <span>- 18 % GST Extra.</span>
                            </div>
                        </li>
                        <li>
                            <div class="invoice__page__terms__item">
                                <span>2.Validity of User ID</span>
                                <span>- 12 months.</span>
                            </div>
                        </li>
                        <li>
                            <div class="invoice__page__terms__item">
                                <span>3.Payment Cycle</span>
                                <span>- Advance Annual.</span>
                            </div>
                        </li>
                        <li>
                            <div class="invoice__page__terms__item">
                                <span class="invoice__page__terms__item__nda">4.Duly signed agreed Non-disclosure Agreement (NDA)</span>
                            </div>
                        </li>
                    </ul>
                    <span class="u-text-medium u-margin-top-medium">Thanking you and assuring our best services at all times.</span>
                    <span class="u-text-medium u-margin-top-small">Yours truly,</span>
                    <span class="u-text-medium u-margin-top-vvsmall">For, ChemRobotics Pvt Ltd. </span>
                    <span class="u-text-medium u-margin-top-vvsmall">Authorized Signatory</span>
                </div>
                <!-- footer -->
                <div class="invoice__page__footer">
                    <hr>
                    <p>Regd. office. Address: House No. 9, Ward No. 23, Jawahar Ganj, Dabra, District Gwalior, Madhya Pradesh 475110 | Cell No.6266117944 | Website: http://chemrobotics.com/  Email: director@chemrobotics.com</p>
                </div>
            </div>
        </div>
       
    </div>

</ng-container>
